import { useCallback } from 'react';
import { monitoringService } from '../services/monitoring';

export function useMonitoring() {
  const trackEvent = useCallback(
    (name: string, properties?: Record<string, unknown>) => {
      monitoringService.trackEvent(name, properties);
    },
    []
  );

  const trackException = useCallback(
    (error: Error, properties?: Record<string, unknown>) => {
      monitoringService.trackException(error, properties);
    },
    []
  );

  const trackPageView = useCallback(
    (name?: string, properties?: Record<string, unknown>) => {
      monitoringService.trackPageView(name, properties);
    },
    []
  );

  const openConsentSettings = useCallback(() => {
    monitoringService.openConsentSettings();
  }, []);

  const trackClarityEvent = useCallback((name: string) => {
    monitoringService.trackClarityEvent(name);
  }, []);

  const trackRedditEvent = useCallback((eventName: string, conversionId?: string) => {
    monitoringService.trackRedditEvent(eventName, conversionId);
  }, []);

  const identifyRedditUser = useCallback((email: string) => {
    monitoringService.identifyRedditUser(email);
  }, []);

  const trackMetaEvent = useCallback((eventName: string, eventId?: string) => {
    monitoringService.trackMetaEvent(eventName, eventId);
  }, []);

  const identifyMetaUser = useCallback((email: string) => {
    monitoringService.identifyMetaUser(email);
  }, []);

  const trackXEvent = useCallback((eventName: string, conversionId?: string) => {
    monitoringService.trackXEvent(eventName, conversionId);
  }, []);

  const identifyXUser = useCallback((email: string) => {
    monitoringService.identifyXUser(email);
  }, []);

  const getClarityId = useCallback(() => {
    return monitoringService.getClarityId();
  }, []);

  const isConsentGiven = monitoringService.isConsentGiven();

  return {
    trackEvent,
    trackException,
    trackPageView,
    trackClarityEvent,
    trackRedditEvent,
    identifyRedditUser,
    trackMetaEvent,
    identifyMetaUser,
    trackXEvent,
    identifyXUser,
    getClarityId,
    openConsentSettings,
    isConsentGiven,
  };
}